import { app } from '@/core/firebase.js'

const firestore = app.firestore()

export { firestore }